import grey from "@material-ui/core/colors/grey";

// Color theme
export const COLOR_BASE = "#18181E";
export const COLOR_DARK = "#18181E";
export const COLOR_HIGH = "#FAB162";
export const COLOR_MID = "#1BA098";
export const COLOR_LOW = "#18181E";
export const COLOR_FONT = grey[100];

// Font size
export const FONT_XBIG = "3rem";
export const FONT_BIG = "2rem";
export const FONT_MED = "1.2rem";
export const FONT_SMALL = "1rem";
export const FONT_XSMALL = "0.7rem";

// Spacing
export const SPACING_XBIG = "200px";
export const SPACING_BIG = "80px";
export const SPACING_MED = "50px";
export const SPACING_SMALL = "30px";
export const SPACING_XSMALL = "15px";
